import { createConfigParametersRepository } from '../../configParametersRepository';
import { MARKETING_PORTAL_COOKIE_NAME } from '../resources/constants';

export const getMktportalParams = () => {
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  const cookie = storageClient?.getCookie(MARKETING_PORTAL_COOKIE_NAME) || '';
  return {
    mktportal: cookie,
  };
};
